import Vue from 'vue';
import Vuex from 'vuex';
import { createVuexStore } from 'vuex-simple';
import { RootStore } from '@/store/modules/store';
Vue.use(Vuex);
// create and export our store
export default createVuexStore(new RootStore());
